export enum Member {
  '$prevCycle' = '$prevCycle',
}
